(function () {
  function initAristaConversion() {
    var root = document.querySelector('[data-arista-conversion]');
    if (!root || root.dataset.aristaReady === 'true') return;
    root.dataset.aristaReady = 'true';

    var q = function (selector, scope) { return (scope || root).querySelector(selector); };
    var qa = function (selector, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(selector)); };
    var cartLayer = q('[data-arista-cart-drawer]');
    var quickviewLayer = q('[data-arista-quickview-modal]');
    var menuLayer = q('[data-arista-menu-drawer]');
    var state = {
      category: 'best-picks',
      price: 'all',
      sort: 'recommended',
      currentProduct: null,
      currentVariant: null,
      cart: null,
      feeds: {},
      loadingMore: false,
      endReached: false
    };

    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (rootPath.slice(-1) !== '/') rootPath += '/';

    var localizationNode = q('[data-arista-localization]');
    var localization = {};
    try { localization = JSON.parse(localizationNode ? localizationNode.textContent : '{}') || {}; } catch (error) { localization = {}; }
    var strings = localization.strings || {};

    function money(cents) {
      var value = Number(cents || 0) / 100;
      var format = localization.moneyFormat || (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) || '';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) return cleanMoneyMarkup(window.Shopify.formatMoney(Math.round(Number(cents || 0)), format));
      if (window.T4SThemeSP && window.T4SThemeSP.Currency && typeof window.T4SThemeSP.Currency.formatMoney === 'function') return cleanMoneyMarkup(window.T4SThemeSP.Currency.formatMoney(Math.round(Number(cents || 0)), format || undefined));
      var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || localization.currency;
      if (!activeCurrency) return String(value);
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: activeCurrency }).format(value); } catch (error) { return String(value); }
    }

    function string(key, fallback) { return strings[key] || fallback || ''; }

    function formatString(template, values) {
      return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) { return values && values[key] != null ? values[key] : match; });
    }

    function cleanMoneyMarkup(value) {
      return String(value == null ? '' : value)
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;|&#x27;/gi, "'")
        .replace(/&amp;/gi, '&')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
      });
    }

    function productFromCard(card) {
      try { return JSON.parse(card.getAttribute('data-product-json') || '{}'); } catch (error) { return {}; }
    }

    function imageFor(product) {
      var image = product.featured_image || (product.images && product.images[0]);
      if (!image) return '';
      return typeof image === 'string' ? image : image.src || image.url || '';
    }

    function firstAvailableVariant(product) {
      var variants = product.variants || [];
      return variants.find(function (variant) { return variant.available !== false; }) || variants[0] || null;
    }

    function monetaryValueInCents(value) {
      if (value == null || value === '') return 0;
      var parsed = parseFloat(value);
      if (!Number.isFinite(parsed)) return 0;
      return typeof value === 'string' ? Math.round(parsed * 100) : Math.round(parsed);
    }

    function priceInCents(variant) {
      return monetaryValueInCents(variant && variant.price);
    }

    function compareInCents(variant) {
      return monetaryValueInCents(variant && variant.compare_at_price);
    }

    function setBodyLocked(locked) {
      document.documentElement.classList.toggle('arista-modal-open', locked);
    }

    function openLayer(layer, opener) {
      [cartLayer, quickviewLayer, menuLayer].forEach(function (candidate) {
        if (candidate && candidate !== layer) closeLayer(candidate);
      });
      if (!layer) return;
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden', 'false');
      setBodyLocked(true);
      if (opener) layer.dataset.opener = opener;
    }

    function closeLayer(layer) {
      if (!layer) return;
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden', 'true');
      if (![cartLayer, quickviewLayer, menuLayer].some(function (candidate) { return candidate && candidate.classList.contains('is-open'); })) setBodyLocked(false);
    }

    function closeAllLayers() {
      closeLayer(cartLayer);
      closeLayer(quickviewLayer);
      closeLayer(menuLayer);
    }

    function priceRange() {
      if (state.price === 'all') return [0, Infinity];
      var parts = state.price.split('-');
      return [Number(parts[0]) * 100, Number(parts[1]) * 100];
    }

    function categoryMatches(widgetKey) {
      if (state.category === 'best-picks') return widgetKey === 'best-picks';
      return state.category === 'all' || state.category === widgetKey;
    }

    function seedBestPicks() {
      var bestPicksWidget = q('[data-arista-widget][data-widget-key="best-picks"]');
      var bestPicksGrid = q('[data-arista-product-grid]', bestPicksWidget);
      if (!bestPicksWidget || !bestPicksGrid || bestPicksGrid.children.length) return;
      ['bogo', 'bestsellers', 'nazariya', 'bracelets', 'trending', 'gifts'].forEach(function (widgetKey) {
        var sourceWidget = q('[data-arista-widget][data-widget-key="' + widgetKey + '"]');
        if (!sourceWidget) return;
        qa('[data-arista-product]', sourceWidget).slice(0, 5).forEach(function (card) {
          bestPicksGrid.appendChild(card.cloneNode(true));
        });
      });
    }

    function updateBogoHeading() {
      var bogoWidget = q('[data-arista-widget][data-widget-key="bogo"]');
      if (!bogoWidget) return;
      var eyebrow = q('.arista-eyebrow', bogoWidget);
      var title = q('.arista-widget-heading h2', bogoWidget);
      if (eyebrow) eyebrow.textContent = string('bogoEyebrow', 'The offer edit');
      if (title) title.textContent = string('bogoTitle', 'Buy 1 Get 1');
    }

    function applyFilters() {
      updateBogoHeading();
      var range = priceRange();
      var total = 0;
      qa('[data-arista-widget]').forEach(function (widget) {
        var categoryMatch = categoryMatches(widget.dataset.widgetKey);
        var visibleInWidget = 0;
        qa('[data-arista-product]', widget).forEach(function (card) {
          var price = Number(card.dataset.price || 0);
          var visible = categoryMatch && price >= range[0] && price <= range[1];
          card.hidden = !visible;
          if (visible) visibleInWidget += 1;
        });
        widget.hidden = !categoryMatch || visibleInWidget === 0;
        total += visibleInWidget;
      });
      var count = q('[data-arista-results-count]');
      if (count) count.textContent = total;
    }

    function setSelected(selector, attribute, value) {
      qa(selector).forEach(function (button) {
        var active = button.getAttribute(attribute) === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function revealCategory(categoryButton) {
      var tabsScroll = q('.arista-tabs-scroll');
      if (!tabsScroll || window.innerWidth > 767 || !categoryButton) return;
      var scrollRect = tabsScroll.getBoundingClientRect();
      var buttonRect = categoryButton.getBoundingClientRect();
      var naturalLeft = tabsScroll.scrollLeft + buttonRect.left - scrollRect.left;
      var targetLeft = naturalLeft - ((tabsScroll.clientWidth - buttonRect.width) / 2);
      var maxScroll = tabsScroll.scrollWidth - tabsScroll.clientWidth;
      tabsScroll.scrollTo({ left: Math.max(0, Math.min(maxScroll, targetLeft)), behavior: 'smooth' });
    }

    function sortProducts() {
      qa('[data-arista-product-grid]').forEach(function (grid) {
        qa('[data-arista-product]', grid).sort(function (a, b) {
          if (state.sort === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
          if (state.sort === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
          return 0;
        }).forEach(function (card) { grid.appendChild(card); });
      });
    }

    function sortLabel(sort) {
      if (sort === 'price-low') return string('priceLow', 'Price low to high');
      if (sort === 'price-high') return string('priceHigh', 'Price high to low');
      return string('recommended', 'Recommended');
    }

    function closeSortMenu() {
      var menu = q('[data-arista-sort-menu]');
      var toggle = q('[data-arista-sort-toggle]');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function setSort(sort) {
      state.sort = sort;
      var sortButton = q('[data-arista-sort-toggle]');
      if (sortButton) sortButton.innerHTML = escapeHtml(sortLabel(sort)) + ' <span aria-hidden="true">⌄</span>';
      qa('[data-arista-sort-option]').forEach(function (option) {
        var isSelected = option.dataset.aristaSortOption === sort;
        option.setAttribute('aria-selected', String(isSelected));
        option.classList.toggle('is-active', isSelected);
      });
      sortProducts();
    }

    function openQuickview(product) {
      var variant = firstAvailableVariant(product);
      if (!variant) return;
      state.currentProduct = product;
      state.currentVariant = variant;
      var image = q('[data-arista-quickview-image]');
      var title = q('[data-arista-quickview-title]');
      var price = q('[data-arista-quickview-price]');
      var compare = q('[data-arista-quickview-compare]');
      var saving = q('[data-arista-quickview-saving]');
      var rating = q('[data-arista-quickview-rating]');
      var description = q('[data-arista-quickview-description]');
      var specs = q('[data-arista-quickview-specs]');
      var select = q('[data-arista-variant-select]');
      var variantWrap = q('[data-arista-variant-wrap]');
      var buyButton = q('[data-arista-quickview-buy]');
      var imageUrl = imageFor(product);

      image.src = imageUrl;
      image.alt = product.title || '';
      title.textContent = product.title || '';
      price.textContent = money(priceInCents(variant));
      var compareCents = compareInCents(variant);
      compare.textContent = compareCents > priceInCents(variant) ? money(compareCents) : '';
      saving.textContent = compareCents > priceInCents(variant) ? formatString(string('save', 'Save {{ amount }}'), { amount: money(compareCents - priceInCents(variant)) }) : '';
      rating.textContent = product.vendor ? formatString(string('rating', '{{ vendor }} · Arista original'), { vendor: product.vendor }) : string('aristaOriginal', 'Arista original');
      description.textContent = String(product.description || product.body_html || string('fallbackDescription', 'A thoughtfully made Arista piece for everyday keeps.')).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 260);
      specs.innerHTML = '';
      [
        [string('material', 'Material'), product.type || string('defaultMaterial', 'Baby jewellery')],
        [string('availability', 'Availability'), variant.available === false ? string('unavailable', 'Currently unavailable') : string('inStock', 'In stock')],
        [string('delivery', 'Delivery'), string('expressDeliveryAvailable', 'Express delivery available')],
        [string('exchange', 'Exchange'), string('lifetimeExchangePolicy', 'Lifetime exchange policy')]
      ].forEach(function (row) {
        var line = document.createElement('p');
        line.innerHTML = '<span>' + escapeHtml(row[0]) + '</span><strong>' + escapeHtml(row[1]) + '</strong>';
        specs.appendChild(line);
      });

      select.innerHTML = '';
      var variants = product.variants || [];
      variants.forEach(function (option) {
        var item = document.createElement('option');
        item.value = option.id;
        item.textContent = (option.title && option.title !== 'Default Title' ? option.title + ' · ' : '') + money(priceInCents(option));
        item.disabled = option.available === false;
        item.selected = String(option.id) === String(variant.id);
        select.appendChild(item);
      });
      variantWrap.hidden = variants.length <= 1;
      buyButton.disabled = variant.available === false;
      buyButton.textContent = variant.available === false ? string('soldOut', 'Sold out') : string('buyNow', 'Buy now →');
      openLayer(quickviewLayer, 'quickview');
    }

    async function addToCart(variantId, quantity, button) {
      if (!variantId) return;
      if (button) { button.disabled = true; button.dataset.originalLabel = button.textContent; button.textContent = string('adding', 'Adding…'); }
      try {
        var response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        await refreshCart();
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
        window.alert(string('cartAddError', 'This piece could not be added right now. Please try again.'));
      } finally {
        if (button) { button.disabled = false; button.textContent = button.dataset.originalLabel || string('buyNow', 'Buy now →'); }
      }
    }

    async function refreshCart(openAfter) {
      try {
        var response = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Unable to load cart');
        state.cart = await response.json();
        renderCart();
        if (openAfter !== false) openLayer(cartLayer, 'cart');
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
        var loadError = q('[data-arista-cart-error]');
        if (loadError) loadError.textContent = string('cartLoadError', 'Your cart could not be loaded. Please try again.');
      }
    }

    function renderCart() {
      if (!state.cart) return;
      var countNodes = document.querySelectorAll('[data-arista-cart-count]');
      Array.prototype.forEach.call(countNodes, function (node) { node.textContent = state.cart.item_count || 0; });
      var items = q('[data-arista-cart-items]');
      var empty = q('[data-arista-cart-empty]');
      var total = q('[data-arista-cart-total]');
      var savings = q('[data-arista-cart-savings]');
      var progress = q('[data-arista-cart-progress]');
      if (!items || !empty || !total || !savings || !progress) return;
      empty.hidden = state.cart.items.length > 0;
      items.innerHTML = state.cart.items.map(function (item, index) {
        var image = item.image || '';
        return '<article class="arista-cart-item">' +
          '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" width="84" height="84">' +
          '<div><h3>' + escapeHtml(item.product_title || item.title) + '</h3>' +
          '<div class="arista-cart-item-price">' + money(item.final_line_price) + '</div>' +
          '<div class="arista-cart-item-actions"><div class="arista-quantity-control"><button type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="' + escapeHtml(string('decrease', 'Decrease quantity')) + '">−</button><span>' + item.quantity + '</span><button type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(string('increase', 'Increase quantity')) + '">+</button></div><button class="arista-cart-remove" type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="0">' + escapeHtml(string('remove', 'Remove')) + '</button></div></div></article>';
      }).join('');
      total.textContent = money(state.cart.total_price);
      savings.textContent = state.cart.total_discount > 0 ? formatString(string('saved', 'You saved {{ amount }} with this pair price.'), { amount: money(state.cart.total_discount) }) : '';
      progress.innerHTML = '<strong>' + escapeHtml(string('pairPricingHeading', 'Pair offer included')) + '</strong>' + escapeHtml(string('pairPricingNote', 'Each offer product includes two pieces at the displayed price. No coupon or extra item is needed.'));
    }

    async function changeCart(line, quantity) {
      try {
        var response = await fetch(rootPath + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        await refreshCart(false);
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
        var updateError = q('[data-arista-cart-error]');
        if (updateError) updateError.textContent = string('cartUpdateError', 'Your cart could not be updated. Please try again.');
      }
    }

    function dynamicCard(product, widgetKey) {
      var variant = firstAvailableVariant(product);
      if (!variant) return '';
      var image = imageFor(product);
      var compare = compareInCents(variant);
      var price = priceInCents(variant);
      var json = escapeHtml(JSON.stringify(product));
      return '<article class="arista-product-card" data-arista-product data-section-key="' + escapeHtml(widgetKey) + '" data-price="' + price + '" data-handle="' + escapeHtml(product.handle) + '" data-variant-id="' + escapeHtml(variant.id) + '" data-available="' + (variant.available !== false) + '" data-product-json="' + json + '">' +
        '<div class="arista-card-media"><a href="#quick-view" class="arista-card-image-link" data-arista-quickview-trigger aria-label="' + escapeHtml(formatString(string('viewProduct', 'View {{ title }}'), { title: product.title })) + '"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="720" height="720" loading="lazy"></a><div class="arista-card-badges">' + (widgetKey === 'bogo' ? '<span class="arista-offer-chip">' + escapeHtml(string('offerChip', 'PAIR OF 2 • PAY FOR 1')) + '</span>' : '') + '</div><button class="arista-quick-view-chip" type="button" data-arista-quickview-trigger>' + escapeHtml(string('quickView', 'Quick view')) + '</button></div>' +
        '<div class="arista-card-body"><div class="arista-card-meta"><h3>' + escapeHtml(product.title) + '</h3></div><div class="arista-card-price-row"><span class="arista-price">' + money(price) + '</span>' + (compare > price ? '<del>' + money(compare) + '</del><span class="arista-saving">' + escapeHtml(formatString(string('save', 'Save {{ amount }}'), { amount: money(compare - price) })) + '</span>' : '') + '</div><button class="arista-buy-button" type="button" data-arista-buy-now' + (variant.available === false ? ' disabled' : '') + '>' + (variant.available === false ? escapeHtml(string('soldOut', 'Sold out')) : escapeHtml(string('buyNow', 'Buy now →'))) + '</button></div></article>';
    }

    async function loadMoreProducts() {
      if (state.loadingMore || state.endReached) return;
      state.loadingMore = true;
      var appended = 0;
      try {
        await Promise.all(qa('[data-arista-widget]').map(async function (widget) {
          var handle = widget.dataset.collectionHandle;
          if (!handle) return;
          if (!state.feeds[handle]) {
            var response = await fetch(rootPath + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250');
            if (!response.ok) return;
            state.feeds[handle] = await response.json();
            state.feeds[handle].next = 0;
          }
          var feed = state.feeds[handle];
          var existing = new Set(qa('[data-arista-product]', widget).map(function (card) { return card.dataset.handle; }));
          var candidates = (feed.products || []).filter(function (product) { return !existing.has(product.handle); }).slice(feed.next, feed.next + 6);
          feed.next += candidates.length;
          if (!candidates.length) return;
          var grid = q('[data-arista-product-grid]', widget);
          candidates.forEach(function (product) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = dynamicCard(product, widget.dataset.widgetKey);
            if (wrapper.firstElementChild) { grid.appendChild(wrapper.firstElementChild); appended += 1; }
          });
        }));
      } catch (error) {
        window.console && console.warn('[Arista infinite scroll]', error);
      }
      state.loadingMore = false;
      if (!appended) {
        state.endReached = true;
        var label = q('[data-arista-load-more-label]');
        if (label) label.textContent = string('allCaughtUp', 'You are all caught up');
      } else {
        applyFilters();
        sortProducts();
      }
    }

    root.addEventListener('click', function (event) {
      var categoryButton = event.target.closest('[data-arista-category]');
      if (categoryButton) {
        state.category = categoryButton.dataset.aristaCategory;
        setSelected('[data-arista-category]', 'data-arista-category', state.category);
        revealCategory(categoryButton);
        applyFilters();
        return;
      }
      var priceButton = event.target.closest('[data-arista-price]');
      if (priceButton) {
        state.price = priceButton.dataset.aristaPrice;
        setSelected('[data-arista-price]', 'data-arista-price', state.price);
        applyFilters();
        return;
      }
      var quickTrigger = event.target.closest('[data-arista-quickview-trigger]');
      if (quickTrigger) {
        event.preventDefault();
        var card = quickTrigger.closest('[data-arista-product]');
        if (card) openQuickview(productFromCard(card));
        return;
      }
      var buyButton = event.target.closest('[data-arista-buy-now]');
      if (buyButton) {
        var buyCard = buyButton.closest('[data-arista-product]');
        if (buyCard) addToCart(buyCard.dataset.variantId, 1, buyButton);
        return;
      }
      var changeButton = event.target.closest('[data-arista-cart-change]');
      if (changeButton) {
        changeCart(changeButton.dataset.line, changeButton.dataset.quantity);
        return;
      }
      var menuLink = event.target.closest('[data-arista-menu-link]');
      if (menuLink) {
        var linkedCategory = menuLink.dataset.aristaCategoryLink;
        var linkTarget = menuLink.getAttribute('href');
        if (!linkedCategory) {
          var menuLinks = qa('.arista-menu-nav > [data-arista-menu-link]');
          var menuIndex = menuLinks.indexOf(menuLink);
          var menuDestinations = [
            { category: 'bogo', target: '#arista-widget-bogo' },
            { category: 'bestsellers', target: '#arista-widget-bestsellers' },
            { category: 'nazariya', target: '#arista-widget-nazariya' },
            { category: 'bracelets', target: '#arista-widget-bracelets' },
            { category: 'trending', target: '#arista-widget-trending' },
            { category: 'trending', target: '#arista-widget-trending' },
            { category: 'gifts', target: '#arista-widget-gifts' }
          ];
          var menuDestination = menuDestinations[menuIndex];
          if (menuDestination) {
            linkedCategory = menuDestination.category;
            linkTarget = menuDestination.target;
          }
        }
        if (linkedCategory) {
          state.category = linkedCategory;
          setSelected('[data-arista-category]', 'data-arista-category', state.category);
          revealCategory(q('[data-arista-category="' + linkedCategory + '"]'));
          applyFilters();
        }
        closeLayer(menuLayer);
        var target = document.querySelector(linkTarget);
        if (target) { event.preventDefault(); setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80); }
        return;
      }
      var widgetLink = event.target.closest('[data-arista-widget-link]');
      if (widgetLink) {
        event.preventDefault();
        var widget = document.getElementById('arista-widget-' + widgetLink.dataset.aristaWidgetLink);
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.addEventListener('click', function (event) {
      var sortToggle = event.target.closest('[data-arista-sort-toggle]');
      if (sortToggle) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var sortMenu = q('[data-arista-sort-menu]');
        var shouldOpen = !!sortMenu && sortMenu.hidden;
        if (sortMenu) sortMenu.hidden = !shouldOpen;
        sortToggle.setAttribute('aria-expanded', String(shouldOpen));
        return;
      }
      var sortOption = event.target.closest('[data-arista-sort-option]');
      if (sortOption) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setSort(sortOption.dataset.aristaSortOption || 'recommended');
        closeSortMenu();
        return;
      }
      if (!event.target.closest('[data-arista-sort-menu]')) closeSortMenu();

      if (event.target.closest('[data-arista-menu-open]')) openLayer(menuLayer, 'menu');
      if (event.target.closest('[data-arista-cart-open]')) { refreshCart(true); }
      if (event.target.closest('[data-arista-menu-close]')) closeLayer(menuLayer);
      if (event.target.closest('[data-arista-cart-close]')) closeLayer(cartLayer);
      if (event.target.closest('[data-arista-quickview-close]')) closeLayer(quickviewLayer);
      var scrollLink = event.target.closest('[data-arista-scroll-link]');
      if (scrollLink) {
        var scrollCategory = scrollLink.dataset.aristaScrollCategory;
        var scrollTargetSelector = scrollLink.dataset.aristaScrollTarget || scrollLink.getAttribute('href') || '#collections';
        var scrollTarget = document.querySelector(scrollTargetSelector);
        if (scrollCategory) {
          state.category = scrollCategory;
          setSelected('[data-arista-category]', 'data-arista-category', state.category);
          revealCategory(q('[data-arista-category="' + scrollCategory + '"]'));
          applyFilters();
        }
        if (scrollTarget) {
          event.preventDefault();
          setTimeout(function () { scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
        }
      }
      if (event.target.closest('[data-arista-sort-toggle]')) {
        state.sort = state.sort === 'recommended' ? 'price-low' : state.sort === 'price-low' ? 'price-high' : 'recommended';
        var label = state.sort === 'recommended' ? string('recommended', 'Recommended') : state.sort === 'price-low' ? string('priceLow', 'Price low to high') : string('priceHigh', 'Price high to low');
        var sortButton = q('[data-arista-sort-toggle]');
        if (sortButton) sortButton.innerHTML = escapeHtml(label) + ' <span aria-hidden="true">⌄</span>';
        sortProducts();
      }
    });

    var variantSelect = q('[data-arista-variant-select]');
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var selected = (state.currentProduct.variants || []).find(function (variant) { return String(variant.id) === String(variantSelect.value); });
      if (!selected) return;
      state.currentVariant = selected;
      q('[data-arista-quickview-price]').textContent = money(priceInCents(selected));
      q('[data-arista-quickview-compare]').textContent = compareInCents(selected) > priceInCents(selected) ? money(compareInCents(selected)) : '';
      q('[data-arista-quickview-saving]').textContent = compareInCents(selected) > priceInCents(selected) ? formatString(string('save', 'Save {{ amount }}'), { amount: money(compareInCents(selected) - priceInCents(selected)) }) : '';
      var button = q('[data-arista-quickview-buy]');
      button.disabled = selected.available === false;
      button.textContent = selected.available === false ? string('soldOut', 'Sold out') : string('buyNow', 'Buy now →');
    });

    var quickviewBuy = q('[data-arista-quickview-buy]');
    if (quickviewBuy) quickviewBuy.addEventListener('click', function () {
      if (state.currentVariant) addToCart(state.currentVariant.id, 1, quickviewBuy);
    });

    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeAllLayers(); });

    var sentinel = q('[data-arista-load-more]');
    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) loadMoreProducts(); }, { rootMargin: '500px 0px' });
      observer.observe(sentinel);
    }

    seedBestPicks();
    var requestedCategory = new URLSearchParams(window.location.search).get('arista_category');
    var allowedCategories = ['best-picks', 'bogo', 'bestsellers', 'nazariya', 'bracelets', 'trending', 'gifts'];
    if (!requestedCategory && window.location.hash === '#arista-widget-bogo') requestedCategory = 'bogo';
    if (allowedCategories.indexOf(requestedCategory) !== -1) {
      state.category = requestedCategory;
      setSelected('[data-arista-category]', 'data-arista-category', state.category);
      revealCategory(q('[data-arista-category="' + state.category + '"]'));
    }
    applyFilters();
    refreshCart(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAristaConversion);
  else initAristaConversion();
})();
